<template>
  <div>
    <!-- 轮播图区域 -->
    <div class="banner">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in bannerData" :key="index">
        <img :src="item.image" alt="Slide" />
      </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
      <!-- <h1>开发区金融服务平台</h1>
      <p>助力企业快速发展，专业的金融服务平台</p> -->
    </div>

    <!-- 数据统计区域 -->
    <section class="stats">
      <div class="stats-container" v-if="statsData!=''">
        <div class="stat-item">
          <h2>{{ statsData.institution_num }}</h2>
          <p>累计融资金额（亿元）</p>
        </div>
        <div class="stat-item">
          <h2>{{ statsData.partner_num }}</h2>
          <p>合作伙伴</p>
        </div>
        <div class="stat-item">
          <h2>{{ statsData.product_num }}</h2>
          <p>服务产品</p>
        </div>
        <div class="stat-item">
          <h2>{{ statsData.enterprise_num }}</h2>
          <p>服务企业数</p>
        </div>
        <div class="stat-item">
          <h2>{{statsData.amount}}</h2>
          <p>当年平均利率</p>
        </div>
      </div>
    </section>

    <!-- 服务区域 -->
    <section class="services">

      <!-- 投融资服务 -->
      <div class="service-category" v-for="(item, index) in navigationData" :key="index">
        <h2>{{ item.title }}</h2>
        <div class="service-grid">
          <div v-for="(itemk, k) in item.list" :key="k" class="service-card" @click="handleClick(itemk)">
             <img :src="itemk.image" style="width: 40px; height: 40px;"  alt="Slide" />
            <h3>{{ itemk.title }}</h3>
            <p>{{ itemk.synopsis }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作伙伴区域 -->
    <section class="partners">
      <div>
        <h1 style="margin-bottom: 50px;">合作机构</h1>
      </div>
      <div class="partners-container">
        <img :src="item.image" alt="合作伙伴1" class="partner-logo" v-for="(item, index) in partnerData" :key="index">
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <p>开发区金融服务平台©2026版权所有</p>
      <p>©致义诚科技 CopyRight© All Rights Reserved  
        &nbsp;&nbsp;<a style=" text-decoration: underline;" href="https://beian.mps.gov.cn/#/query/webSearch">京公网安备11011202102232号</a> 
        &nbsp;&nbsp;<a style=" text-decoration: underline;" href="https://beian.miit.gov.cn/">京ICP备2025113771号-1</a>
      </p>
      <p><a style=" text-decoration: underline;" href="https://oss.tskjgw.com/file/jyxkz.png">增值电信业务经营许可证：京B2-20261881</a> 技术支持：北京致义诚科技有限公司 | 电话：{{ statsData.contact }} | 邮箱：{{ statsData.email }}</p>
      <!-- <p><span @click="relateTap" style="cursor: pointer;">企业展示</span></p> -->
    </footer>
  </div>
</template>
<script>
// let that='';
// import ChinaAreaCascader from '@/components/ChinaAreaCascader.vue'
export default {
  name: 'HomeView',
  // components:{
  //    ChinaAreaCascader
  // },
  data() {
    return {
      msg: 'Home_page',
      bannerData:[],
      swiperOption: {
        loop: false, // 循环播放
        autoplay: {
          delay: 3000, // 自动播放间隔
          disableOnInteraction: false // 用户操作后不停止
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      // 金融产品
      navigationData:[],
      // 合作机构
      partnerData:[],
      // 数据统计
      statsData:'',
      
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    // that=this;
     this.getBannerAjax();
     this.getPartnerAjax();
     this.getAjax();
  },
  activated(){
     this.getNavigationAjax();
  },
  methods: {
    // 获取首页轮播图
    getBannerAjax(){
      let data={
        type:1
      }
      this.$http.getBannerAjax(data).then(res=>{
        if(res.code==1){
          let listData=res.data;
          if(listData.length>0){
            this.bannerData=listData;
            //  listData.forEach(item=>{
            //   //  item.imageUrl=that.$http.baseURL+item.imageUrl;
            //   if(item.title=='首页'){
            //     this.bannerData=[item];
            //   }
              
            //  })
          }
          
        }else{
          this.$message.info(res.msg);
        }
      }).catch(()=>{
        this.$message.info('获取轮播图失败');
      })
    },
    // 获取首页数据统计
    getAjax(){
        let data={}
        this.$http.getTotlaAjax(data).then(res=>{
          if(res.code==1){
            this.statsData=res.data;
          }else{
            this.$message.info(res.msg);
          }
        }).catch(()=>{
          this.$message.info('获取数据统计失败');
        })
    },
    // 获取首页合作伙伴
    getPartnerAjax(){
      let data={}
      this.$http.getPartnerAjax(data).then(res=>{
        if(res.code==1){
          this.partnerData=res.data;
        }else{
          this.$message.info(res.msg);
        }
      }).catch(()=>{
        this.$message.info('获取合作伙伴失败');
      })
    },
    // 获取首页金融产品
    getNavigationAjax(){
      let data={}
      this.$http.getNavigationAjax(data).then(res=>{
        if(res.code==1){
          this.navigationData=res.data;
        }else{
          this.$message.info(res.msg);
        }
      }).catch(()=>{
        this.$message.info('获取金融产品失败');
      })
    },
    // 点击金融产品跳转
    handleClick(itemk){//item
      console.log(itemk.type);
      // if(!localStorage.getItem('token')){
      //     this.$message.info('请先登录');
      //     return;
      // }
      if(itemk.type==0){//跳转详情页
         this.$router.push({
            path:'/details',
            query:{
              id:itemk.id,
              title:itemk.title,
              descText:itemk.synopsis,
            }
          })
          let pathObj = {
            path: '/',
            pathTop:0
          }
          localStorage.setItem('urlObj', JSON.stringify(pathObj));
      }else{//跳转列表页
          this.$router.push({
            path:'/service',
            query:{
              id:itemk.id
            }
          })
          let pathObj = {
            path: '/service',
            pathTop:1
          }
          localStorage.setItem('urlObj', JSON.stringify(pathObj));
      }
    },
    relateTap(){
      this.$router.push('/contact');
      let pathObj = {
            path: '/contact',
            pathTop:3
          }
          localStorage.setItem('urlObj', JSON.stringify(pathObj));
    }
    
  }
}
</script>
<style lang="scss" scoped>
/* 轮播图区域 */
.banner {
  height: 400px;
  // background: linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2)), url('@/assets/banner.jpg');
  background-size: cover;
  background-position: center;
  color: #fff;
  text-align: center;
  // padding-top: 120px;
  .swiper-container {
    width: 100%;
    height: 400px; /* 根据需要调整高度 */
  }
  .swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.banner h1 {
  font-size: 36px;
  margin-bottom: 20px;
}

.banner p {
  max-width: 800px;
  margin: 0 auto;
  font-size: 18px;
  margin-bottom: 30px;
}

/* 数据统计区域 */
.stats {
  background-color: #fff;
  padding: 40px 0;
}

.stats-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  padding: 0 20px;
}

.stat-item {
  text-align: center;
  padding: 0 20px;
}

.stat-item h2 {
  font-size: 36px;
  color: #1890ff;
  margin-bottom: 10px;
}

.stat-item p {
  font-size: 16px;
  color: #666;
}

/* 服务区域 */
.services {
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
}

.service-category {
  margin-bottom: 40px;
}

.service-category h2 {
  font-size: 24px;
  color: #1890ff;
  margin-bottom: 10px;
  padding-left: 10px;
  border-left: 8px solid #1890ff;
  text-align: left;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.service-card {
  background-color: #f5f7fa;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s ease;
}

.service-card:hover {
  background-color: #e6f7ff;
  transform: translateY(-5px);
}

.service-card i {
  font-size: 24px;
  color: #1890ff;
  margin-bottom: 10px;
}

.service-card h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 5px;
}

.service-card p {
  font-size: 14px;
  color: #666;
}

/* 合作伙伴区域 */
.partners {
  background-color: #fff;
  padding: 40px 0;
  text-align: center;
}

.partners-container {
  /* max-width: 1200px;*/
  margin: 0 auto;
}

.partner-logo {
  width: 200px;
  height: 100px;
  margin: 0 20px;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.partner-logo:hover {
  opacity: 1;
}

/* 页脚 */
.footer {
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 40px 20px;
  margin-top: 40px;
}

.footer p {
  font-size: 14px;
  margin-bottom: 5px;
}

.footer a {
  color: #fff;
  text-decoration: none;
}

.footer a:hover {
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .service-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .stats-container {
    flex-direction: column;
    gap: 30px;
  }

  .banner h1 {
    font-size: 28px;
  }

  .banner p {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .service-grid {
    grid-template-columns: 1fr;
  }

  .nav-links {
    display: none;
  }
}

</style>